const lockerPortalUrl = process.env.VUE_APP_LOCKER_PORTAL_URL || 'https://puyu-locker.tih.tw/'

const runtimeConfig = {
  lockerPortalUrl
}

export default runtimeConfig
